export default __webpack_public_path__ + "static/media/rlf.25e3554b.jpg";